import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import DataSnapshots from "components/Private/BaolinEventsAnalytics/BudhaBath/DataSnapshots";
import ChartsContext from "../../contexts/ChartsContext";

// react-bootstrap components
import {
    Container,
} from "react-bootstrap";
import InsightCharts from "components/Private/BaolinEventsAnalytics/BudhaBath/InsightCharts";

function BudhaBathDashboard() {
    const { setChartsData, setUpdateTime } = useContext(ChartsContext);
    const fetchEventStatistics = () => {
        axios.get(`${process.env.REACT_APP_SERVER_URL}/budhabath/geteventstatistics?event=budhabath`)
            .then(response => {
                const currentTime = new Date().toLocaleString();
                setUpdateTime(currentTime);
                console.log("Buddha Bathing API Response Data:", response.data);

                setChartsData(response.data);
            })
            .catch(error => {
                console.error("Error fetching event statistics:", error);
            });
    };

    useEffect(() => {
        fetchEventStatistics(); // Initial data fetch
    }, []);

    return (
        <>
            <Container fluid>
                <DataSnapshots onRefresh={fetchEventStatistics} />
                <InsightCharts onRefresh={fetchEventStatistics} />
            </Container>
        </>
    );
}

export default BudhaBathDashboard;
